import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';

@Component({
    selector: 'app-login-redirect',
    templateUrl: './login-redirect.component.html',
    styleUrls: ['./login-redirect.component.scss']
})
export class LoginRedirectComponent implements OnInit {

    constructor(private route: ActivatedRoute, private keycloakService: KeycloakService) {
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            const redirectUrl = decodeURIComponent(params.url);
            this.keycloakService.login({
                locale: localStorage.getItem('languageCode'),
                redirectUri: redirectUrl
            });
        });
    }
}
